export const purchase = {
  label: 'Pembelian',
  from: 'Pembelian dari',
  to: 'Pembelian ke',
  amount: 'Jumlah',
  mobileNumber: 'Nomor Ponsel',
  customerNumber: 'No Pelanggan',
  voucherNumber: 'Nomor Voucher',
  voucherNumberTelkomselPackageData: 'Voucher SN',
  placeholder: {
    autocomplete: 'Pilih jenis pembelian',
    operator: 'Pilih Operator',
    reloadType: 'Pilih jenis Isi Ulang',
    serviceType: 'Pilih Jenis Layanan',
    phoneNumberNote: 'Pastikan nomor telepon yang dimasukkan benar',
  },
  modal: {
    title: 'Pembelian untuk {billerName}',
    paymentCode: 'Kode Pembayaran',
    operator: 'Operator Seluler',
  },
  errorMessage: {
    invalidPaymentCode: 'Kode Pembayaran tidak sesuai',
  },
};
